webpackJsonp([214740112983436],{

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _gatsbyLink = __webpack_require__(161);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactScroll = __webpack_require__(83);
	
	var _Blocks = __webpack_require__(93);
	
	var _Blocks2 = _interopRequireDefault(_Blocks);
	
	var _Link = __webpack_require__(55);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _utils = __webpack_require__(56);
	
	var _pageHomeModule = __webpack_require__(731);
	
	var _pageHomeModule2 = _interopRequireDefault(_pageHomeModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home(_ref) {
	  var _ref$pathContext = _ref.pathContext,
	      subparts = _ref$pathContext.subparts,
	      images = _ref$pathContext.images;
	
	  var _sanitizeContent = (0, _utils.sanitizeContent)(subparts, 'ueberuns', 'verwaltung', 'verkauf', 'dataprivacy', 'dataprocessing'),
	      ueberuns = _sanitizeContent.ueberuns,
	      verwaltung = _sanitizeContent.verwaltung,
	      verkauf = _sanitizeContent.verkauf;
	
	  var _sanitizeContent2 = (0, _utils.sanitizeContent)(images, 'header', 'verkauf', 'verwaltung'),
	      _sanitizeContent2$hea = _sanitizeContent2.header,
	      headerImage = _sanitizeContent2$hea[0].image,
	      _sanitizeContent2$ver = _sanitizeContent2.verkauf,
	      verkaufImage = _sanitizeContent2$ver[0].image,
	      _sanitizeContent2$ver2 = _sanitizeContent2.verwaltung,
	      verwaltungImage = _sanitizeContent2$ver2[0].image;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactScroll.Element,
	      { name: 'home' },
	      _react2.default.createElement('div', { className: _pageHomeModule2.default.headerImage, style: { backgroundImage: 'url(' + headerImage.file.url + ')' } }),
	      _react2.default.createElement(
	        'div',
	        { className: _pageHomeModule2.default.wrapper },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'IVM Immobilienverwaltung Meyer GmbH'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Verkauf \u2013 Vermietung \u2013 Verwaltung'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Link2.default, { simple: true, name: 'MEHR ERFAHREN', tag: 'h4', onClick: function onClick() {
	                return (0, _utils.scrollToElement)('#mehr');
	              } }),
	            _react2.default.createElement(_Link2.default, { simple: true, name: 'KONTAKT AUFNEHMEN', tag: 'h4', onClick: function onClick() {
	                return (0, _utils.scrollToElement)('#kontakt');
	              } })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactScroll.Element,
	      { name: 'ueberuns' },
	      _react2.default.createElement(_Blocks2.default, { headerTag: 'h1', content: ueberuns })
	    ),
	    _react2.default.createElement(
	      _reactScroll.Element,
	      { name: 'mehr' },
	      _react2.default.createElement(
	        _reactScroll.Element,
	        { name: 'verkauf' },
	        _react2.default.createElement(_Blocks2.default, {
	          headerTag: 'h2',
	          content: [_extends({}, verkauf[0], { onMore: function onMore() {
	              return (0, _gatsbyLink.navigateTo)('/verkauf');
	            }, onContact: function onContact() {
	              return (0, _utils.scrollToElement)('#kontakt');
	            } }), { image: verkaufImage.file.url }]
	        })
	      ),
	      _react2.default.createElement(
	        _reactScroll.Element,
	        { name: 'verwaltung' },
	        _react2.default.createElement(_Blocks2.default, {
	          headerTag: 'h2',
	          content: [{ image: verwaltungImage.file.url }, _extends({}, verwaltung[0], { onMore: function onMore() {
	              return (0, _gatsbyLink.navigateTo)('/verwaltung');
	            }, onContact: function onContact() {
	              return (0, _utils.scrollToElement)('#kontakt');
	            } })]
	        })
	      )
	    )
	  );
	};
	
	Home.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    subparts: _propTypes2.default.array.isRequired,
	    images: _propTypes2.default.array.isRequired,
	    references: _propTypes2.default.array.isRequired
	  })
	};
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerImage":"src-templates----page-home-module---headerImage---11cq4","wrapper":"src-templates----page-home-module---wrapper---3eJxj"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-home-js-f30b00129658ec1064f2.js